import { RootFiSyncQuery } from '@commenda/types/src/root-fi/types';
import { fetcher } from '@commenda/utils';

export async function syncRootFiInvoices(
  query: RootFiSyncQuery,
  token?: string
) {
  const res = await fetcher(
    `rootFi/invoices/sync`,
    {
      method: 'POST',
      body: query,
    },
    token
  );

  return res;
}
